<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="dedi1"><em class="italic">To my sons: Samuel Washington Maloy and Thomas Mercer Maloy.</em></p>
<p class="dedi"><em class="italic">I hope one day, you too will find inspiration from the heroes of the past…</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?5ca2d9f6